import React, { useEffect, useState } from 'react';
import { formInputTextErrorStyle, routes } from 'Utility/constants';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as actions from '../../../redux/actions/index';
import { connect, useDispatch, useSelector } from 'react-redux';
import { validateResetForm } from '../../../Utility/validator/formValidation';
import Loader from 'react-loader-spinner';

const ChangePassword = (props) => {
   let dispatch = useDispatch();

   const [visible, setVisible] = useState({password: false, confirmPassword: false})

   const initialFormValues = {
      password: '',
      password_confirmation: '',
   };

   const handleVisible = (type) => {
      if(type === 'password') {
         setVisible({...visible, password: !visible.password})
      } else {
         setVisible({...visible, confirmPassword: !visible.confirmPassword})
      }
   }


   useEffect(() => {
      if (
         props.resetPasswordSuccessAPI &&
         props.resetPasswordSuccessAPI.success === true
      ) {
         console.log('Going Login');
         props.history.push(routes.LOGIN);
      }
   }, [props.resetPasswordSuccessAPI]);

   let isLoading = useSelector((state) => state.authReducer.isLoading);
   return (
      <div id="wrap">
         <div className="wrap-login100">
            <Formik
               initialValues={initialFormValues}
               onSubmit={(values) => {
                  debugger;
                  let params = new URLSearchParams(props.history.location.search);
                  let reset_password_token = params.get('reset_password_token');
                  dispatch(
                     actions.resetPassword({
                        user: {
                           ...values,
                           reset_password_token: reset_password_token,
                        },
                     })
                  );
               }}
               validate={(values) => validateResetForm(values)}
            >
               <Form className="login100-form validate-form">
                  <span className="login100-form-title">Reset Password</span>
                  <fieldset className="form_fields">
                     <div className="form-group" style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                           <Field
                              className="input_modify"
                              type={visible.password ? 'text' : 'password'}
                              name="password"
                              placeholder="New Password"
                              style={{ width: "100%" }}
                           />
                           <span
                              onClick={() => handleVisible('password')}
                              style={{
                                 position: 'absolute',
                                 top: '50%',
                                 right: '10px',
                                 transform: 'translateY(-50%)',
                                 cursor: 'pointer',
                                 zIndex: 2,
                                 display: 'flex',
                                 alignItems: 'center',
                                 height: '100%',
                              }}
                           >
                              {!visible.password ? (
                                 <i className="fa fa-eye-slash" aria-hidden="true"></i>
                              ) : (
                                 <i className="fa fa-eye" aria-hidden="true"></i>
                              )}
                           </span>
                        </div>
                        <ErrorMessage
                           name="password"
                           render={(msg) => (
                              <span style={formInputTextErrorStyle}>{msg}</span>
                           )}
                        />
                     </div>
                     <div className="form-group" style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                           <Field
                              className="input_modify"
                              type={visible.confirmPassword ? 'text' : 'password'}
                              name="password_confirmation"
                              placeholder="Confirm Password"
                              style={{ width: "100%" }}
                           />
                           <span
                              onClick={() => handleVisible('confirmPassword')}
                              style={{
                                 position: 'absolute',
                                 top: '50%',
                                 right: '10px',
                                 transform: 'translateY(-50%)',
                                 cursor: 'pointer',
                                 zIndex: 2,
                                 display: 'flex',
                                 alignItems: 'center',
                                 height: '100%',
                              }}
                           >
                              {!visible.confirmPassword ? (
                                 <i className="fa fa-eye-slash" aria-hidden="true"></i>
                              ) : (
                                 <i className="fa fa-eye" aria-hidden="true"></i>
                              )}
                           </span>
                        </div>
                        <ErrorMessage
                           name="password_confirmation"
                           render={(msg) => (
                              <span style={formInputTextErrorStyle}>{msg}</span>
                           )}
                        />
                     </div>
                  </fieldset>
                  <div className="form-group text-center">
                     <button
                        disabled={isLoading ? true : false}
                        type="submit"
                        className="theme_btn theme_primary btn-block"
                     >
                        {isLoading ? (
                           <Loader
                              type="Circles"
                              color="#FFF"
                              height={25}
                              width={80}
                           />
                        ) : (
                              'Submit'
                           )}
                     </button>
                  </div>
                  <div className="ihweb_flex_btwn_Vc text-center"></div>
               </Form>
            </Formik>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      resetPasswordSuccessAPI: state.authReducer.resetPasswordSuccessAPI,
   };
};

const RResetPassword = connect(mapStateToProps)(ChangePassword);

export default withRouter(RResetPassword);
